/*
 * @Autor: GeekMzy
 * @Date: 2022-04-14 13:56:43
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-04-29 15:07:15
 * @FilePath: \htwlgs-drainage-webv2-shiju\src\main.ts
 * @Author: desktop-1llkr2o
 */
import '@/assets/styles/global.scss'
import pinia from '@/store/index'
import clickOutside from '@/utils/clickOutside.js'
import * as echarts from 'echarts'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import locale from 'element-plus/lib/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import Highcharts3D from 'highcharts/highcharts-3d'
import HighchartsMore from 'highcharts/highcharts-more'
// import vue3SeamlessScroll from 'vue3-seamless-scroll'
import Highcharts from 'highcharts/highstock'
import HighchartsDrilldown from 'highcharts/modules/drilldown'
import moment from 'moment'
import naive from 'naive-ui'
import 'video.js/dist/video-js.css'
import 'videojs-contrib-hls'
import { createApp } from 'vue'
import App from './App.vue'
// import './assets/styles/theme.scss'
import './assets/styles/global.scss'
import { router } from './router/router'
import { Api } from '@/api/publicApi'

const app = createApp(App)

app.provide('moment', moment)
HighchartsMore(Highcharts)
HighchartsDrilldown(Highcharts)
Highcharts3D(Highcharts)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(ElementPlus, { locale })
app.use(router)
app.use(pinia)
app.use(naive)
// app.use(vue3SeamlessScroll, { name: 'vue3-seamless-scroll' })
app.directive('clickOutside', clickOutside)

//--------------------------------------请求公共下拉参数-----------------------------------------
// // 全局参数
app.config.globalProperties.$echarts = echarts
app.config.globalProperties.$highCharts = Highcharts

// const api = new Api()
// api.screen.problemTypeDropBoxUsingPost().then((res) => {
//   if (res.code === 200) {
//     app.config.globalProperties.problemTypeList = res.data?.map((item: any) => {
//       return {
//         label: item.name,
//         value: item.value,
//       }
//     })
//   }
// })

// app.config.errorHandler = (err, vm, info) => {
//   console.log(err, vm, info, 'vue error')
// }

// app.config.warnHandler = (msg, vm, trace) => {
//   if (!process.env.VUE_APP_BASE_PROD) {
//     console.log(msg, vm, trace, 'vue warn')
//   }
// }

app.mount('#app')
